import { inject, Injectable } from '@angular/core';

import { EnvironmentDomain } from '../../environments/environment.model';
import { EnvironmentService } from '../../environments/environment.service';

@Injectable({
  providedIn: 'root',
})
export class DomainService {
  private readonly envService = inject(EnvironmentService);
  private readonly location = inject(Location);

  private normaliseUrl(url: string): string {
    return new URL(url, this.location.href).origin.toLowerCase();
  }

  private getEnvironmentDomain(url: string): EnvironmentDomain | undefined {
    const origin = this.normaliseUrl(url);
    return this.envService.env.domains[origin];
  }

  public isCDFUrl(url: string = ''): boolean {
    return !!this.getEnvironmentDomain(url);
  }

  public isInternetUrl(url: string = '') {
    return this.getEnvironmentDomain(url)?.realm === 'internet';
  }

  public isIntranetUrl(url: string = '') {
    return this.getEnvironmentDomain(url)?.realm === 'intranet';
  }
}
